import { buildNodeDetailTabUrl, NodeDetailTabTarget } from './nodeDetailTabUrl';

export type NetworkScanDetailTarget = NodeDetailTabTarget;

/**
 * Deep link into the installed base tree with the "Network scan" tab open
 * (IBM-1039). Targets the node the effective scan is documented on when it
 * is part of the path; otherwise the node itself (where the user may document
 * one).
 */
export const buildNetworkScanDetailUrl = (
    ownNodeId: string | undefined | null,
    pathNodeIds: ReadonlyArray<string | undefined | null>,
    sourceNodeId?: string | null,
): NetworkScanDetailTarget => buildNodeDetailTabUrl(ownNodeId, pathNodeIds, 'networkScan', sourceNodeId);
